export const addForecastToRouteQueryString = (routeTo, currentRoute) => {
  return {
    ...routeTo,
    query: { ...(routeTo?.query || {}), forecast: currentRoute.query?.forecast },
  };
};
